import {Card} from 'antd';
import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "./deferLoaderHoc";
import CompanyCard from "./CompanyCard";
import * as R from 'ramda';
import {currentEffectiveUserId} from "../../reducers/ui";

const ContactCard = ({ user, company, ...rest }) => {
  const {
    firstname,
    lastname,
    title,
    email,
    phone,
    fax,
    cell,
    companyid,
    companyadmin,
    userinitialized,
  } = (user.resource || user);
  if (email && !userinitialized) {
    return (
      <Card
        {...rest}
        className='contact-card-flex'
        title={<div>
          <h4><a href={'mailto:' + email}>{email}</a></h4>
        </div>}
      />
    );
  } else {
    const full_name = [firstname, lastname].filter(i => i).join(' ') || 'No Name';
    return (
      <Card
        {...rest}
        className='contact-card-flex'
        title={<div>
          <h3>{full_name}</h3>
          <h4>{company ? company.resource.companyname : ''}</h4>
          {companyadmin && <h5>(Company Admin)</h5>}
        </div>}
      >
        <div className='contact-card-flex-body'>
          <div className='contact-card-flex-info'>
            <div>{title}</div>
            <div><a href={'mailto:' + email}>{email}</a></div>
            <div>p: <a href={'tel:' + phone}>{phone}</a></div>
            <div>f: <a href={'tel:' + fax}>{fax}</a></div>
            <div>c: <a href={'tel:' + cell}>{cell}</a></div>
          </div>
          <div className='contact-card-flex-company'>
            <CompanyCard id={companyid}/><br/>
          </div>
        </div>
      </Card>
    );
  }
};

ContactCard.propTypes = {};

export default compose(
    connect(
        (state, ownProps) => {
            let user = R.view(R.lensPath(R.append(ownProps.id, ownProps.path || ['users', 'data'])))(state);
            const currentUser = currentEffectiveUserId(state);
            if (!user) return {loading: true};
            let company = state.companies.data[(user.resource || user).companyid];
            return {user, company, currentUser};
        },
        (dispatch, props) => ({ loader: props.loader })
    ),
    withLoading
)(ContactCard);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/ContactCardFlex.js